import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useRestrictedActionIndexState() {
  return useAppState();
}

export function useRestrictedActionIndexActions() {
  const dispatch = useAppDispatch();

  function initializeState() {
    dispatch((appState) => ({
      ...appState,
      loading: true,
      restrictedActions: [],
      restrictedActionModalIsOpen: false,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function onResponse(response) {
    dispatch((appState) => ({ ...appState, ...response }));
  }

  function onError(feedback) {
    dispatch((appState) => ({ ...appState, ...feedback }));
  }

  function openRestrictedActionModal() {
    dispatch((appState) => ({
      ...appState,
      restrictedActionModalIsOpen: true,
    }));
  }

  function closeRestrictedActionModal() {
    dispatch((appState) => ({
      ...appState,
      restrictedActionModalIsOpen: false,
    }));
  }

  function getFeedbackFromLocalStorage(feedbackMessage, feedbackVariant) {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: feedbackMessage,
      feedbackVariant: feedbackVariant,
    }));
  }

  function clearFeedback() {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  return {
    initializeState,
    onResponse,
    onError,
    openRestrictedActionModal,
    closeRestrictedActionModal,
    getFeedbackFromLocalStorage,
    clearFeedback,
  };
}
